import { FocusTrap as OriginalFocusTrap, FocusTrapProps } from 'focus-trap-react';

export const FocusTrap = (prop: FocusTrapProps) => {
  return <OriginalFocusTrap {...prop} />;
};
